import {Component} from "@angular/core";
import {ViewController, Events, NavParams} from "ionic-angular";
import {UserService} from "../../../pages/shared/user/user.service";

@Component({
  templateUrl: 'interpreter-search-modal.component.html',
})
export class InterpreterSearchModal {
  interpreters: any[];

  constructor(private viewCtrl: ViewController,
              private events: Events,
              private userService: UserService,
              private navParams: NavParams
  ) {
  }

  dismiss() {
    return this.viewCtrl.dismiss();
  }

  selectInterpreter(interpreter){
    let event = this.navParams.get('event') || 'interpreter:selected';
    console.log(event);
    this.events.publish(event, interpreter);
    this.dismiss();
  }

  getInterpreters(ev: any){
    let val = ev.target.value;
    if(!val || val.trim() === ''){
      return;
    }

    this.userService.getInterpreters(val)
      .subscribe(users => {
        this.interpreters = users;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/interpreter-search-modal/interpreter-search-modal.component.ts